import { useQuery } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';

export const FindHostsQueryKey = 'find-hosts';

export const useFindHostsQuery = () =>
  useQuery(FindHostsQueryKey, async () => {
    const { data } = await apiCpService.getHostsCpClientHostsGet();

    return Object.entries(data);
  });
